<template>
  <modal
    name="email-preview"
    height="auto"
    width="800"
  >
    <modal-title class="m-4">
      Email Preview
    </modal-title>
    <div
      class="email-preview-content"
      v-html="emailHtml"
    />
  </modal>
</template>

<script>
import ModalTitle from '@/components/ModalTitle'
import gateway from '@/gateway'

export default {
  components: {
    ModalTitle,
  },

  props: {
    html: {
      required: false,
      type: String,
      default: null,
    },
  },

  data () {
    return {
      emailHtml: this.html,
    }
  },

  methods: {
    async preview (resource, id, draft = false, showModal = true) {
      /*
        router.get('/alerts/html/newsletter-draft/:id', this.getNewsletterDraftHtml.bind(this))
        router.get('/alerts/html/newsletter/:id', this.getNewsletterHtml.bind(this))
        router.get('/alerts/html/article-draft/:id', this.getArticleDraftHtml.bind(this))
        router.get('/alerts/html/article/:id', this.getArticleHtml.bind(this))
        router.get('/alerts/:id/html', this.getAlertHtml.bind(this))
      */

      let url = 'alerts/'
      url += resource === 'alerts' ? `${id}/preview` : `previews/${id}/${resource}`

      try {
        const response = await gateway.get(url)
        this.emailHtml = response.data.data.html

        if (showModal) {
          this.$modal.show('email-preview')
        } else {
          return this.emailHtml
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss">
.email-preview-content {
  padding: 1.5rem 1.5rem 0;
  overflow-y: auto;
  // fixes a bug in IE
  flex-basis: 60vh;
  flex-grow: 1;
}
</style>

